<template>
  <provider-show-section :title="$t('PLACEHOLDERS.contacts')">
    <div class="provider_show_grid provider_show_grid--1">
      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.contactPhoneNumbers") }}</span>
        <div v-if="phones.length" class="provider_show_chips">
          <span
            v-for="(phone, index) in phones"
            :key="'phone-' + index"
            class="provider_show_chip provider_show_value--ltr"
          >
            <i class="fas fa-phone-alt"></i>
            {{ phone }}
          </span>
        </div>
        <p v-else class="provider_show_value mb-0">-</p>
      </div>

      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.WhatsApp_contact") }}</span>
        <p class="provider_show_value provider_show_value--ltr">
          <template v-if="whatsapp">
            <i class="fab fa-whatsapp provider_show_whatsapp"></i>
            {{ whatsapp }}
          </template>
          <template v-else>-</template>
        </p>
      </div>
    </div>
  </provider-show-section>
</template>

<script>
import ProviderShowSection from "./ProviderShowSection.vue";

export default {
  name: "ProviderShowContacts",
  components: { ProviderShowSection },
  props: {
    phones: { type: Array, default: () => [] },
    whatsapp: { type: String, default: null },
  },
};
</script>
